<template>
  <div>
    <audio
        style="display:none"
        :ref="`ks_audio_player_${_uid}`"
        @timeupdate='onTimeUpdate'
        preload="none"
    >
      <source :src="_url" type="audio/mpeg"/>
      <source src="track.ogg" type="audio/ogg"/>
      Your browser does not support the audio element.
    </audio>

    <div class="d-flex"
         :style="showRange ? `box-shadow: black 0px 8px 6px -6px;
                padding: 10px;
                border: solid .01rem #a8a9a9;
            ` : ''">
      <div>
        <button type="button" class="btn btn-dark" :class="buttonSize" @click="toggleAudio()" v-show="!isPlaying"
                style="border-radius: 1.5rem">
          <i class="fas fa-play"></i>
        </button>

        <button type="button" class="btn btn-dark" :class="buttonSize" @click="toggleAudio()" v-show="isPlaying"
                style="border-radius: 1.5rem">
          <i class="fas fa-pause"></i>
        </button>
      </div>

      <div class="mt-1 ml-2" style="width: 100%" v-if="showRange">
        <input
            style="width: 100%"
            class="form-range"
            v-model="playbackTime"
            type="range"
            min="0"
            :max="audioDuration"
            id="position"
            name="position"
            autocomplete="new-password"
        />

        <!-- Show loading indicator until audio has been loaded -->
        <div v-if="!audioLoaded"> Loading please wait...</div>
        <div v-else="audioLoaded">
          <span class="text-sm"> {{ currentTime }} </span>
          <span class="text-sm" style="float:right"> {{ convertTime(audioDuration) }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppWrapper from '../../appWrapper.vue';

export default {
  name: "audio-player",
  props: {
    buttonSize: {
      type: String,
      default: 'btn-lg'
    },
    url: {
      type: String,
      required: true
    },
    private: {
      type: Boolean,
      default: false
    },
    showRange: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      player: null,
      playbackTime: 0,
      audioDuration: 0,
      audioLoaded: false,
      isPlaying: false,
      currentTime: "00:00"
    };
  },
  computed: {
    _url() {
      return `${this.url}${this.private ? `?token=${app.auth.urlToken}` : ''}`;
    }
  },
  methods: {
    onTimeUpdate() {
      if (this.player) {
        this.playbackTime = this.player.currentTime;
        this.currentTime = this.convertTime(this.player.currentTime);
      } else {
        this.currentTime = this.convertTime(0);
      }
    },
    //Set the range slider max value equal to audio duration
    initSlider() {
      if (this.player) {
        this.audioDuration = Math.round(this.player.duration);
      }
    },
    //Convert audio current time from seconds to min:sec display
    convertTime(seconds) {
      if (seconds > 0) {
        const format = val => `0${Math.floor(val)}`.slice(-2);
        let hours = seconds / 3600;
        let minutes = (seconds % 3600) / 60;
        return [minutes, seconds % 60].map(format).join(":");
      } else {
        return '00:00';
      }
    },
    //Playback listener function runs every 100ms while audio is playing
    playbackListener(e) {
      //Sync local 'playbackTime' var to audio.currentTime and update global state

      //Add listeners for audio pause and audio end events
      this.player.addEventListener("ended", this.endListener);
      this.player.addEventListener("pause", this.pauseListener);
    },
    //Function to run when audio is paused by user
    pauseListener() {
      this.isPlaying = false;
      this.listenerActive = false;
      this.cleanupListeners();
    },
    //Function to run when audio play reaches the end of file
    endListener() {
      this.isPlaying = false;
      this.listenerActive = false;
      this.cleanupListeners();
    },
    //Remove listeners after audio play stops
    cleanupListeners() {
      this.player.removeEventListener("freqtimeupdate", this.playbackListener);
      this.player.removeEventListener("ended", this.endListener);
      this.player.removeEventListener("pause", this.pauseListener);
    },
    toggleAudio() {
      //var audio = document.getElementById("audio-player");
      if (this.player.paused) {
        this.player.play();
        this.isPlaying = true;
      } else {
        this.player.pause();
        this.isPlaying = false;
      }
    },
  },
  mounted() {
    // nextTick code will run only after the entire view has been rendered
    this.$nextTick(() => {
      this.player = this.$refs[`ks_audio_player_${this._uid}`];
      //Wait for audio to load, then run initSlider() to get audio duration and set the max value of our slider
      this.player.addEventListener(
          "loadedmetadata",
          function (e) {
            this.initSlider();
          }.bind(this)
      );

      this.player.addEventListener(
          "canplay",
          function (e) {
            this.audioLoaded = true;
          }.bind(this)
      );

      //Wait for audio to begin play, then start playback listener function
      this.$watch("isPlaying", () => {
        if (this.isPlaying) {
          this.initSlider();
          //prevent starting multiple listeners at the same time
          if (!this.listenerActive) {
            this.listenerActive = true;
            this.player.addEventListener("freqtimeupdate", this.playbackListener);
          }
        }
      });

      //Update current audio position when user drags progress slider
      this.$watch("playbackTime", () => {
        let diff = Math.abs(this.playbackTime - this.player.currentTime);
        //Throttle synchronization to prevent infinite loop between playback listener and this watcher
        if (diff > 0.01) {
          this.player.currentTime = this.playbackTime;
        }
      });
    });
  }

};
</script>
